export const routes_names = {
  // public
  uptimekuma_dashboard: 'uptimekuma_dashboard',
  esxi_servers_dashboard: 'esxi_servers_dashboard',
  ipmi_servers_dashboard: 'ipmi_servers_dashboard',
  ilo_servers_dashboard: 'ilo_servers_dashboard',
  call_fail: 'call-fail',
  check_fail: 'check-fail',
  check_redis_fail: 'check-redis-fail',
  // auth
  login: 'login',
  // dashboard
  main: 'main',
  cp_detect_pincodes: 'pincodes',
  cp_detect_centeral_points: 'centeral_points',
  cp_detect_document_approvals: 'document_approvals',
  error_capture_cors_allowed_domains: 'cors_allowed_domains',
  error_capture_sip_incoming_call_tests: 'sip_incoming_call_tests',
  error_capture_errors: 'errors',
  error_capture_sip_logs: 'sip_logs',
  error_capture_web_sip_logs: 'web_sip_logs',
  error_capture_user_actions: 'user_actions',
  error_capture_uptime_kuma_services: 'uptime_kuma_services',
  error_capture_agents: 'agents',
  automation_credentials: 'automation_credentials',
  automation_servers: 'automation_servers',
  automation_loud_test: 'automation_loud_test',
  universal_ai_servers: 'servers',
  universal_ai_api_keys: 'api_keys',
  universal_ai_logs: 'logs',
  call_stats_filters: 'call_stats_filters',
  call_stats_thresholds: 'call_stats_thresholds',
  call_stats_sip_servers: 'call_stats_sip_servers',
  call_stats_call_hangup_reports: 'call_stats_call_hangup_reports',
}
